import type { Transition } from "@uirouter/core";

import categoryService from "app/common/services/categoryService";
import type { prioritizedTransitionHookFn } from "app/routes/handlers/redirectFunctions/redirectPipe";
import { CategoryServiceUtils } from "app/services/CategoryServiceUtils";

import { LEGACY_ROUTES } from "../routes/routes";

/**
 * navigate to the industry overview page if the user selects industry with segment
 * */
export const onRedirectUnSupportedIndustryWithSegmentsPage =
    (fallbackState = LEGACY_ROUTES.overview): prioritizedTransitionHookFn =>
    (transition: Transition) => {
        const toParams = transition.params();
        const { category } = toParams;
        const categoryObject = categoryService.categoryQueryParamToCategoryObject(category);
        const selectedCustomIndustryHasSegments = CategoryServiceUtils.hasSegments(categoryObject);
        if (selectedCustomIndustryHasSegments) {
            return fallbackState;
        }
    };
